/**
 * DAKAR AUTOMÓVEIS — WhatsApp
 * ------------------------------------------------------------------
 * - Botão fixo "Atendimento" (todas as páginas)
 * - Botão "Falar com Atendente" da página do carro (normal e fixo no rodapé)
 * - Mensagem já vem com o nome do carro, o preço e o link
 * - Cada clique é contado como LEAD no Pixel da Meta e no Google (se estiverem instalados)
 * Os dados do carro vêm de window.DAKAR, definido no layout/theme.liquid.
 */
(function () {
  var cfg = window.DAKAR || {};
  var numero = cfg.whatsapp || '5519999421514';
  var produto = cfg.produto;

  function montarMensagem() {
    if (produto && produto.titulo) {
      var msg = 'Olá, Dakar! Tenho interesse no ' + produto.titulo;
      msg += produto.preco ? ' (' + produto.preco + ')' : ' — quero saber as condições';
      msg += '. Vi no site: ' + produto.url;
      return msg;
    }
    return 'Olá, Dakar! Vim pelo site e quero ajuda para escolher um carro.';
  }

  function linkWhatsApp() {
    return 'https://wa.me/' + numero + '?text=' + encodeURIComponent(montarMensagem());
  }

  function registrarLead(origem) {
    var dados = {
      content_name: produto ? produto.titulo : 'Atendimento geral',
      origem: origem
    };
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Contact', dados); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { method: 'whatsapp', item_name: dados.content_name, origem: origem }); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'whatsapp_click', item_name: dados.content_name, origem: origem }); } catch (e) {}
  }

  function abrirWhatsApp(origem) {
    registrarLead(origem);
    window.open(linkWhatsApp(), '_blank', 'noopener');
  }

  // Botão fixo "Atendimento"
  document.querySelectorAll('.dakar_wpp_button').forEach(function (btn) {
    btn.href = linkWhatsApp();
    btn.setAttribute('rel', 'noopener');
    btn.addEventListener('click', function () { registrarLead('botao_flutuante'); });
  });

  // Botões "Falar com Atendente" (página do carro, barra fixa e visualização rápida).
  // Fica escutando a página inteira, então pega também botões que aparecem depois.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.product-form__add-button');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    abrirWhatsApp(btn.id === 'StickyAddToCart' ? 'barra_fixa_produto' : 'botao_produto');
  }, true);

  // Qualquer outro link de WhatsApp do site (drone, simular parcela...) também conta como lead
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
    if (!link || link.classList.contains('dakar_wpp_button')) return;
    registrarLead(link.getAttribute('data-dakar-origem') || (link.closest('[data-dds]') ? 'drone_home' : 'link_whatsapp'));
  });

  // Segurança: se algum formulário de produto tentar ir para o carrinho, manda para o WhatsApp.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
      event.preventDefault();
      event.stopPropagation();
      abrirWhatsApp('formulario_produto');
    }
  }, true);
})();
